import { UserAddOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { memo, useContext, useMemo } from 'react';
import { ConversationContext } from '../../contexts/ConversationContext';

const AddGroupMemberForm = ({
  openModalAdd,
  handleCancelModalAdd,
  conversation,
  users,
  handleCancelModal,
}) => {
  const { addUserToGroupChat } = useContext(ConversationContext);

  const userIds = useMemo(
    () => conversation?.users?.map((user) => user?.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [conversation?.users?.length]
  );

  return (
    <Modal
      open={openModalAdd}
      title="Add member to group"
      onCancel={handleCancelModalAdd}
      footer={[
        <Button key="back" onClick={handleCancelModalAdd}>
          Close
        </Button>,
      ]}
    >
      {users?.map(
        (user) =>
          !userIds?.includes(user?.id) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              key={user?.id}
            >
              <p>{user?.fullName}</p>
              <Button
                ghost
                type="primary"
                icon={<UserAddOutlined />}
                onClick={() => {
                  addUserToGroupChat(conversation?.id, user?.id);
                  handleCancelModalAdd();
                  handleCancelModal();
                }}
              />
            </div>
          )
      )}
    </Modal>
  );
};

export default memo(AddGroupMemberForm);
